<template>
  <v-dialog max-width="650" v-model="dialog" @keydown.enter.prevent="onenter">
    <v-card>
      <v-card-title>
        <span class="headline">Magical Cinema Bundle ({{ this.rules.name }})</span>
      </v-card-title>
      <v-card-text>
        <v-row dense>
          <v-col cols="12" md="12" sm="12">
            <v-text-field disabled label="UID:" v-model.trim="model.uid" hide-details outlined dense/>
          </v-col>
          <v-col cols="12" md="4" sm="4">
            <v-text-field
                label="Name"
                v-model.trim="model.name"
                v-ascii-only
            />
          </v-col>
          <v-col cols="12" md="4" sm="4">
            <v-text-field
                label="Key"
                v-model.trim="model.key"
                v-ascii-only
            />
          </v-col>
        </v-row>
        <v-expansion-panels class="mb-5">
          <r-guard-panel :model.sync="model.guard" title="Guard Config"/>
          <r-smart-offer-reset-currency :items.sync="model.resetCurrency" title="Reset Currency"/>
        </v-expansion-panels>
        <v-expansion-panels class="mb-5">
          <r-product-panel :items.sync="model.products" :kinds="product_group" title="Products"/>
          <r-reward-track-panel :model.sync="model.rewardTrack" title="Reward Track"/>
        </v-expansion-panels>
      </v-card-text>
      <v-card-actions>
        <v-spacer/>
        <v-btn @click="cancel" color="blue darken-1" text>
          Cancel
        </v-btn>
        <v-btn @click="save" color="blue darken-1" text>
          Save
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>

import {ViewRules} from "@/common/ViewRules";
import {ProductGroupKind} from "@/modules/redactor/models/product/ProductGroupKind";
import {SmartOfferBundleMagicalCinema} from "@/modules/redactor/models/smart-offer/bundle-magical-cinema/SmartOfferBundleMagicalCinema";

import RGuardPanel from "@/modules/redactor/views/guard/r-guard-panel.vue";
import RSmartOfferResetCurrency from "@/modules/redactor/views/smart-offer/r-smart-offer-reset-currency.vue";
import RProductPanel from "@/modules/redactor/views/product/r-product-panel.vue";
import RRewardTrackPanel from "@/modules/redactor/views/reward/r-reward-track-panel.vue";



export default {
  name: "r-smart-offer-bundle-magical-cinema",
  components: {RRewardTrackPanel, RProductPanel, RSmartOfferResetCurrency, RGuardPanel},
  data: () => ({
    dialog: false,
    resolve: null,
    reject: null,
    tab: null,
    model: new SmartOfferBundleMagicalCinema(),
    rules: ViewRules.READONLY,
  }),
  computed: {
    product_group() {
      return [ProductGroupKind.SMART_OFFERS]
    }
  },
  methods: {
    show(rules, model) {
      this.dialog = true;
      this.tab = null;
      this.rules = rules;
      this.model = model || new SmartOfferBundleMagicalCinema();

      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },
    save() {
      if (this.model.valid()) {
        this.resolve(this.model);
        this.discard();
      } else {
        this.$alert("Invalid config!");
      }
    },
    cancel() {
      this.reject();
      this.discard();
    },
    discard() {
      this.dialog = false;
    },
    onenter() {
      this.save();
    }
  }
}
</script>
